"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoCard = InfoCard;
var _CardActions2 = _interopRequireDefault(require("@mui/material/CardActions"));
var _CardContent2 = _interopRequireDefault(require("@mui/material/CardContent"));
var _Card2 = _interopRequireDefault(require("@mui/material/Card"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function InfoCard({
  error,
  Icon,
  iconBackground,
  iconProps,
  description,
  descriptionProps,
  actions,
  onClose,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_Card2.default, props, /*#__PURE__*/_react.default.createElement(StyledCardContent, null, iconBackground ? /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    borderRadius: 4,
    display: "flex",
    height: 32,
    justifyContent: "center",
    sx: {
      backgroundColor: '#fff'
    },
    width: 32
  }, /*#__PURE__*/_react.default.createElement(Icon, _extends({
    color: error ? 'error' : 'primary'
  }, iconProps))) : /*#__PURE__*/_react.default.createElement(Icon, _extends({
    color: error ? 'error' : 'primary'
  }, iconProps)), /*#__PURE__*/_react.default.createElement(_Typography2.default, _extends({
    alignSelf: "center",
    color: "textSecondary",
    variant: "caption"
  }, descriptionProps), description), onClose && /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "left",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    onClick: onClose,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Close2.default, null)))), actions && /*#__PURE__*/_react.default.createElement(StyledCardActions, null, actions));
}
const StyledCardContent = (0, _styledComponents.styled)(_CardContent2.default)`
  align-items: flex-start;
  display: flex;

  &&& {
    padding-bottom: 16px;
  }

  > *:not(:first-child) {
    margin-left: 16px;
  }

  svg {
    flex-shrink: 0;
  }

  button {
    flex-shrink: 0;
  }
`;
const StyledCardActions = (0, _styledComponents.styled)(_CardActions2.default)`
  padding: 8px 16px;

  > *:not(:first-child) {
    margin-left: 16px;
  }
`;